/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { useFeatureFlag } from '../FeatureFlags/index.js';
import { OverflowMenu as OverflowMenu$2 } from './next/index.js';
import { OverflowMenu as OverflowMenu$1 } from './OverflowMenu.js';

const OverflowMenu = /*#__PURE__*/forwardRef((props, ref) => {
  const enableV12OverflowMenu = useFeatureFlag('enable-v12-overflowmenu');
  return enableV12OverflowMenu ? /*#__PURE__*/React.createElement(OverflowMenu$2, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(OverflowMenu$1, _extends({}, props, {
    ref: ref
  }));
});
OverflowMenu.displayName = 'OverflowMenu';
OverflowMenu.propTypes = OverflowMenu$1.propTypes;

export { OverflowMenu, OverflowMenu as default };
